import { Disclosure, Transition } from "@headlessui/react";
import React from "react";
import type { Properties } from "./properties";

const AccordionCardView = React.memo((props: Properties) => {
	const getChildrenContent = () => (
		<Transition
			as={React.Fragment}
			show={props.open}
			enter="transform transition duration-100"
			enterFrom="opacity-0 scale-y-50"
			enterTo="opacity-100 scale-y-100"
			leave="transform duration-100 transition ease-in-out"
			leaveFrom="opacity-100 scale-y-100"
			leaveTo="opacity-0 scale-y-50"
		>
			<Disclosure.Panel className={"origin-top"}>
				{props.children ? props.children : undefined}
			</Disclosure.Panel>
		</Transition>
	);

	const getHeaderContent = () => {
		const header = props.headerContent ? props.headerContent : undefined;

		return (
			<>
				{!props.children || props.locked ? (
					header
				) : (
					<Disclosure.Button
						onClick={() =>
							props.onToggleOpen ? props.onToggleOpen() : undefined
						}
					>
						{header}
					</Disclosure.Button>
				)}
			</>
		);
	};

	return (
		<div className={["flex", "flex-col", "grow", props.className].join(" ")}>
			<Disclosure>
				<>
					{getHeaderContent()}
					{getChildrenContent()}
				</>
			</Disclosure>
		</div>
	);
});

export { AccordionCardView };
